(function () {
  'use strict';

  var breakpoint = window.matchMedia('(min-width: 990px)');
  var activeProduct = null;
  var movedElements = [];
  var resizeTimer = null;

  function findProduct() {
    var main = document.querySelector("main#MainContent[data-template='product']");
    if (!main) return null;
    return main.querySelector('product-info .product');
  }

  function prepareElements(product) {
    if (activeProduct === product && movedElements.length) return;

    activeProduct = product;
    movedElements = [];

    var promoBox = product.querySelector("[id^='promo-box-']");
    if (!promoBox) return;

    /* Recenzia evidențiată și descrierea rămân în coloana de cumpărare.
       Doar demonstrațiile vizuale trec în zona lată de sub produs. */
    var elements = promoBox.querySelectorAll('.pretivo-side-gif');

    elements.forEach(function (element, index) {
      var marker = document.createComment('pretivo-desktop-position-' + index);
      element.parentNode.insertBefore(marker, element);
      movedElements.push({ element: element, marker: marker });
    });
  }

  function createStory(product) {
    var story = product.parentNode.querySelector(':scope > .pretivo-desktop-story');
    if (story) return story;

    story = document.createElement('div');
    story.className = 'pretivo-desktop-story';
    story.setAttribute('data-pretivo-desktop-story', 'true');
    product.insertAdjacentElement('afterend', story);
    return story;
  }

  function moveForDesktop(product) {
    if (!movedElements.length) return;
    var story = createStory(product);

    movedElements.forEach(function (entry) {
      if (entry.element && entry.element.isConnected) {
        story.appendChild(entry.element);
      }
    });
  }

  function restoreForMobile() {
    movedElements.forEach(function (entry) {
      if (!entry.marker || !entry.marker.parentNode || !entry.element) return;
      entry.marker.parentNode.insertBefore(entry.element, entry.marker.nextSibling);
    });

    document.querySelectorAll('.pretivo-desktop-story').forEach(function (story) {
      story.remove();
    });
  }

  function applyLayout() {
    var product = findProduct();
    if (!product) return;

    if (activeProduct !== product || !movedElements.length) {
      prepareElements(product);
    }

    if (breakpoint.matches) {
      moveForDesktop(product);
    } else {
      restoreForMobile();
    }
  }

  function scheduleLayout() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(applyLayout, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyLayout);
  } else {
    applyLayout();
  }

  window.addEventListener('resize', scheduleLayout, { passive: true });
  document.addEventListener('shopify:section:load', function () {
    activeProduct = null;
    movedElements = [];
    scheduleLayout();
  });
})();
